import { render, staticRenderFns } from "./FooterLogo.vue?vue&type=template&id=267e46b6&"
import script from "./FooterLogo.vue?vue&type=script&lang=js&"
export * from "./FooterLogo.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogo.vue?vue&type=style&index=0&id=267e46b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports